"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagBase = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var core_1 = require("@material-ui/core");
var TagLabel_1 = require("./TagLabel");
var TagCount_1 = require("./TagCount");
var TagIcon_1 = require("./TagIcon");
exports.TagBase = function (_a) {
    var count = _a.count, label = _a.label, truncate = _a.truncate, icon = _a.icon, onDelete = _a.onDelete, className = _a.className, _b = _a.small, small = _b === void 0 ? false : _b;
    var tagData = (react_1.default.createElement(react_1.default.Fragment, null,
        label && react_1.default.createElement(TagLabel_1.TagLabel, { label: label, truncate: truncate }),
        count && react_1.default.createElement(TagCount_1.TagCount, { count: count })));
    return (react_1.default.createElement(StyledChip, { icon: icon ? react_1.default.createElement(TagIcon_1.TagIcon, { icon: icon }) : undefined, label: tagData, deleteIcon: react_1.default.createElement("i", { className: "icon--close" }), onDelete: onDelete, className: className, small: small }));
};
var StyledChip = styled_components_1.default(function (_a) {
    var small = _a.small, props = tslib_1.__rest(_a, ["small"]);
    return (react_1.default.createElement(core_1.Chip, tslib_1.__assign({}, props, { classes: { deleteIcon: 'deleteIcon', label: 'label' } })));
})(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  && {\n    background-color: ", ";\n    border-radius: 1.3rem;\n    color: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    margin: 0.2rem;\n    padding: 0.2rem 1.2rem;\n    height: auto;\n    font-family: ", ";\n    display: inline-flex;\n    align-items: center;\n  }\n\n  &&:hover {\n    filter: brightness(0.9) saturate(3);\n    cursor: pointer;\n  }\n\n  && > i {\n    color: ", ";\n  }\n\n  && .label {\n    padding: 0px;\n  }\n\n  && .deleteIcon {\n    margin: 0 0 0 0.8rem;\n    height: 100%;\n    width: auto;\n    align-items: center;\n    color: ", ";\n    font-size: 1.4rem;\n    display: block;\n  }\n"], ["\n  && {\n    background-color: ", ";\n    border-radius: 1.3rem;\n    color: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    margin: 0.2rem;\n    padding: 0.2rem 1.2rem;\n    height: auto;\n    font-family: ", ";\n    display: inline-flex;\n    align-items: center;\n  }\n\n  &&:hover {\n    filter: brightness(0.9) saturate(3);\n    cursor: pointer;\n  }\n\n  && > i {\n    color: ", ";\n  }\n\n  && .label {\n    padding: 0px;\n  }\n\n  && .deleteIcon {\n    margin: 0 0 0 0.8rem;\n    height: 100%;\n    width: auto;\n    align-items: center;\n    color: ", ";\n    font-size: 1.4rem;\n    display: block;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.fadedBlue;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.darkBlue[500];
}, function (_a) {
    var small = _a.small;
    return (small ? '1.2rem' : '1.3rem');
}, function (_a) {
    var small = _a.small;
    return (small ? '1.5rem' : '1.8rem');
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.robotoRegular;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.darkBlue[500];
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.NTWarmGrey[600];
});
var templateObject_1;
